import { defaultClassPrefix, prefix } from './prefix';
import classNames from 'classnames';
import { useCallback } from 'react';
export default function useClassNames(componentClassName) {
  var className = defaultClassPrefix('icon');
  var addPrefix = useCallback(function (blockClassName) {
    return prefix(className, blockClassName);
  }, []);
  return [classNames(className, defaultClassPrefix(componentClassName)), addPrefix];
}